export const INSTALLMENT_OPTIONS = {
  annual: 1,
  '2_pay': 2,
  '3_pay': 3,
  '4_pay': 4,
};

export const PAYMENT_PERIOD_LABELS: Record<string, string> = {
  annual: 'Annual',
  monthly: 'Monthly',
  '2_pay': '2 Pay',
  '3_pay': '3 Pay',
  '4_pay': '4 Pay',
};

export const AGENCY_INFO: Record<
  string,
  { name: string; description: string }
> = {
  facility: {
    name: 'Facility Association',
    description:
      'This policy will be billed through Facility Association agency billing program.',
  },
};
